/**
 * Normalize an Axios error into a stable { message, status, data } shape.
 * @param {import('axios').AxiosError|Error} error
 * @returns {{ message: string, status?: number, data?: unknown }}
 */
export const normalizeError = (error) => {
  let errorMessage = 'An unexpected error occurred';
  const data = error.response?.data;
  if (data) {
    if (data.message) {
      if (Array.isArray(data.message)) {
        errorMessage = data.message.join(', ');
      } else if (typeof data.message === 'string') {
        errorMessage = data.message;
      }
    } else if (data.response) {
      if (Array.isArray(data.response)) {
        errorMessage = data.response.join(', ');
      } else if (typeof data.response === 'string') {
        errorMessage = data.response;
      }
    } else if (data.error) {
      errorMessage = data.error;
    }
  } else if (error.message) {
    errorMessage = error.message;
  }

  return {
    message: errorMessage,
    status: error.response?.status,
    data: error.response?.data,
  };
};
